import { isTeamBiDirectionalEnabled as getIsTeamBiDirectionalEnabled } from '../../../../common/utils/utils';
import { useTeamSelectorContext } from '../../../../controllers/team-selector-context';

// clean this hook when clean up "edit-team-connection-from-confluence" experiment
export const useTeamBiDirectionalExp = () => {
	const { containerType } = useTeamSelectorContext();
	const isTeamBiDirectionalEnabled = getIsTeamBiDirectionalEnabled(containerType);

	return {
		isTeamBiDirectionalEnabled,
	};
};
